import { type FC } from 'react';
import PhotoHeart from 'dibs-interiors-photos/exports/PhotoHeart.tsx';
import ShareWrapper from 'dibs-interiors-photos/exports/ShareWrapper.tsx';
import classnames from 'classnames';
import { useServerVars } from '../../shared/ServerVarsContext.tsx';

import styles from './SocialIconsWrapper.scss';

type Props = {
    additionalSpacing?: boolean;
    photoNodeId: string;
    photoId: string;
    photoLikeId: string;
    onPhotoLikeAdded: () => void;
    firmName: string;
    projectName: string;
    projectUrl: string;
    photoPath: string;
    photoUrl: string;
    showPhotoHeart?: boolean;
    totalPhotoLikes?: number;
};

const SocialIconsWrapper: FC<Props> = props => {
    const {
        additionalSpacing,
        photoNodeId,
        photoId,
        photoLikeId,
        onPhotoLikeAdded,
        firmName,
        projectName,
        projectUrl,
        photoUrl,
        showPhotoHeart = true,
        totalPhotoLikes,
        photoPath,
    } = props;

    const { isMobile, isDesktop } = useServerVars();

    return (
        <div
            className={classnames(styles.wrapper, {
                [styles.additionalSpacing]: additionalSpacing,
            })}
        >
            {showPhotoHeart && (
                <PhotoHeart
                    photoNodeId={photoNodeId}
                    photoId={photoId}
                    photoLikeId={photoLikeId}
                    onPhotoLikeAdded={onPhotoLikeAdded}
                    tooltipDirection="bottom"
                    isMobile={isMobile}
                    totalPhotoLikes={totalPhotoLikes}
                />
            )}
            <ShareWrapper
                isDesktop={!!isDesktop}
                firmName={firmName}
                projectName={projectName}
                projectUrl={projectUrl}
                photoUrl={photoUrl}
                photoPath={photoPath}
            />
        </div>
    );
};

export default SocialIconsWrapper;
